module.exports = __webpack_public_path__ + "static/fanruan-topic.196734bd.png";